// extracted by mini-css-extract-plugin
export default {"container":"QSqqb4","image":"hZSyIr","desktop":"al_Z_u","mobile":"tJFr1E","imageFit":"e_MLm5"};